import { render, staticRenderFns } from "./withdrawalsRecord.vue?vue&type=template&id=0c1ed2fa&"
import script from "./withdrawalsRecord.vue?vue&type=script&lang=js&"
export * from "./withdrawalsRecord.vue?vue&type=script&lang=js&"
import style0 from "./withdrawalsRecord.vue?vue&type=style&index=0&id=0c1ed2fa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports